import React, { useState, useEffect, useRef } from 'react'
import { NavLink, useNavigate } from "react-router-dom";
import styled from 'styled-components';
import AppBreadcrumbs from './breadcrumbs/AppBreadcrumbs';
import { FaSearch, FaBars, FaShoppingCart, FaCog } from 'react-icons/fa';
import { useCart } from '../store/CartContext';
import { FaFacebook } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa6";

import { FaTelegramPlane } from "react-icons/fa";
import { FaTwitter, FaPinterest } from "react-icons/fa";

const LayoutWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  background-color: white;
`;


const HeaderDiv = styled.div`
  background-color: ${window.ENV.HEADER.BACKGROUND_COLOR};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: ${window.ENV.HEADER.HEIGHT || 130}px;
  min-height: 100px;
  color: ${window.ENV.HEADER.TEXT_COLOR};
  padding: 0 5px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    padding: 10px;
    flex-wrap: wrap;
    justify-content: space-between;
  }
    
`;


const HeaderNav = styled.nav`
  display: flex;
  gap: 20px;
  align-items: center;
  color: ${window.ENV.HEADER.TEXT_COLOR};
  font-weight: ${window.ENV.HEADER.FONT_WEIGHT};
  margin-left: 10px; /* Push menu options to the right */
  margin-right: 240px; /* Add some space from the right edge */
  
  /* Desktop (1200px and above) */
  @media (min-width: 1200px) {
    margin-right: 40px;
  }
  
  /* Tablet (768px to 1199px) */
  @media (min-width: 768px) and (max-width: 1199px) {
    margin-right: -40px;
    margin-left: 70px;
  }
  
  /* Mobile (below 768px) */
  @media (max-width: 767px) {
    display: ${props => props.open ? 'flex' : 'none'};
    flex-direction: column;
    position: absolute;
    top: 100px;
    right: 0;
    left: 0;
    background-color: ${window.ENV.HEADER.BACKGROUND_COLOR};
    padding: 20px;
    z-index: 100;
    margin-left: 0;
    margin-right: 0;
  }
`;

const HeaderImg = styled.img`
  position: absolute;
  left: 50px;
  top: ${window.ENV.LOGO_TOP || "15px"};
  max-width: ${window.ENV.LOGO_WIDTH};

  @media (max-width: 768px) {
    position: relative;
    left: 0;
    top: 10px;
    margin-bottom: 10px;
    max-width: 100px;
  }
`;


const HamburgerIcon = styled.div`
  display: none;
  cursor: pointer;

  @media (max-width: 768px){
    display: block;
    position: relative;
    right: 5px; 
    top: 7px;
    padding-left: 10px; 
  }
`;


const InputWrapper = styled.div`
  position: relative;
  width: 33%;
  display: flex;
  justify-content: flex-end;
  margin-right: 20px;

  @media (max-width: 768px){
    width: 65%; /* Give more room on small screens */
    justify-content: center;
    margin-right:0px;
    margin: -60px  0px 0px 95px;
    order: 3; /* Push it below the logo and nav */  
  }
`;


const StyledInput = styled.input`
  padding: 7px 60px 7px 10px;
  font-size: 12px;
  border: 0.5px solid ${window.ENV.GENERAL.BACKGROUND_COLOR};
  font-family: ${window.ENV.FONT_FAMILY || 'UP-Book, sans-serif'};
  // border-radius: 4px;
  color: ${window.ENV.GENERAL.TEXT_COLOR};
  background-color: #f4f4f4;
  width: 58%;
  &:hover {
    background-color: ${window.ENV.GENERAL.BACKGROUND_COLOR};
    color: ${window.ENV.GENERAL.HOVER_TEXT_COLOR};
  }
  @media(max-width: 768px){
   width:80%;
   margin-right: 20px;
   padding-right:52px;
   marign-botton:20px;
}
`;

const SearchIconWrapper = styled.div`
  position: absolute;
  right: 10px;
  top: 49%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${window.ENV.GENERAL.TEXT_COLOR};
  &:hover {
    color: ${window.ENV.GENERAL.HOVER_TEXT_COLOR};
  }
  @media(max-width: 768px){
    right: 10px;
    top: 49%;
    
    margin-right: 30px;
  }
`;

const CartIconWrapper = styled.div`
  margin-right: 20px;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  color: ${window.ENV.GENERAL.TEXT_COLOR};
  transition: color 0.3s ease;

  &:hover {
    color: ${window.ENV.GENERAL.HOVER_TEXT_COLOR};
  }

  @media (max-width: 768px) {
    margin-right: 10px;
    margin-left: 10px;
    order: 2;
  }
`;


const CartBadge = styled.span`
  position: absolute;
  top: -8px;
  right: -8px;
  background: #dc3545;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;

  @media (max-width: 768px) {
    width: 18px;
    height: 18px;
    font-size: 10px;
  }
`;

const ConfiguratorIconWrapper = styled.div`
  margin-right: 20px;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  color: ${window.ENV.GENERAL.TEXT_COLOR};
  transition: color 0.3s ease;

  &:hover {
    color: ${window.ENV.GENERAL.HOVER_TEXT_COLOR};
  }

  @media (max-width: 768px) {
    margin-right: 10px;
    margin-left: 10px;
    order: 2;
  }
`;


const SearchResults = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: #f4f4f4;
  border: 1px solid ${window.ENV.HOVER_COLOR};
  color: black;
  border-radius: 4px;
  width: 58%;
  max-height: 200px;
  overflow-y: auto;
  z-index: 100;
  font-family: ${window.ENV.FONT_FAMILY || 'UP-Book, sans-serif'};

  &:hover {
    color: ${window.ENV.HOVER_COLOR};
  }

  @media (max-width: 768px) {
    right: 10px;
    width:90%;
  }
`;

const BreadcrumbsDiv = styled.div`
`;

// ---- Footer Styled Components ----
const FooterDiv = styled.footer`
  background-color: ${window.ENV.FOOTER.BACKGROUND_COLOR};
  padding: 40px 40px 0;
  color: ${window.ENV.FOOTER.TEXT_COLOR};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 30px;
  height: ${window.ENV.FOOTER.HEIGHT || "230px"};
  width: 100%;

  @media (max-width: 768px) {
    width:100%;
    height: 100%;
    flex-direction: row;
    padding: 20px 20px 0;
    align-items: center;
    text-align: center;
    margin-top: 20px;

  }
`;

const FooterColumn = styled.div`
  flex: 1;
  min-width: 200px;
  padding: 0 10px;

  @media (max-width: 768px) {
    padding: 0;
  }
`;

const FooterColumnLogo = styled(FooterColumn)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media (max-width: 768px) {
    align-items: center;
  }
`;
const FooterHeading = styled.h3`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: white;
`;

const FooterNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 10px;

  a {
    color: ${window.ENV.FOOTER.TEXT_COLOR};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const FooterLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FooterLogo = styled.img`
margin-top: ${window.ENV.FOOTER.LOGO_TOP || "20px"};
max-width: ${window.ENV.FOOTER.LOGO_WIDTH || "190px"};
min-width: 100px;
  opacity: 0.8;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 1;
  }
  @media (max-width: 768px) {
    max-width: 100px;
  }
`;

const FooterIcons = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 15px;
  margin-right: 40px;
  @media (max-width: 768px) {
    margin-right: 0px;
  }
`;

const FooterText = styled.p`
  font-size: 14px;
  color: ${window.ENV.FOOTER.TEXT_COLOR};
  margin-bottom: 10px;
  @media (max-width: 768px) {
    text-align: center;
    margin-left:5px;
  }
`;

const FooterCopyRight = styled.div`
  width: 100%;
  height: ${window.ENV.FOOTER.COPYRIGHT_HEIGHT || "80px"};
  text-align: center;
  color: ${window.ENV.FOOTER.COPYRIGHT_TEXT_COLOR || 'white'};
  margin: 0;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${window.ENV.FOOTER.COPYRIGHT_BACKGROUND_COLOR || window.ENV.FOOTER.BACKGROUND_COLOR};
  
  @media (max-width: 768px) {
    height: 100%;
    min-height: ${window.ENV.FOOTER.COPYRIGHT_HEIGHT || "80px"};
    padding: 15px 10px;
    font-size: 12px;
  }
  
  @media (max-width: 480px) {
    font-size: 11px;
    padding: 10px 5px;
    height: 100%;

  }
`;

const FooterColumnResponsive = styled(FooterColumn)`
  @media (max-width: 768px) {
    flex: 1 100%;
    text-align: center;
  }
`;
const FooterLine = styled.div`
  width: 80%;
  height: 1px;
  background-color: ${window.ENV.FOOTER.LINE_COLOR || 'white'};
  margin: 0px auto;
  margin-bottom: 0px !important;
  min-width: 80%;
  max-width: 80%;
  @media (max-width: 756px){
  background-color: #000000;
  }
`;

const SecondaryHeader = styled.div`
  background-color: ${window.ENV.HEADER.SECONDARY_HEADER_BACKGROUND_COLOR};
  height: ${window.ENV.HEADER.SECONDARY_HEADER_HEIGHT};
  padding: 5px 0;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  @media (max-width: 768px) {
    width: 100%;
`;

const SecondaryHeaderText = styled.p`
  color: ${window.ENV.HEADER.SECONDARY_HEADER_TEXT_COLOR};
  font-size: 14px;
  font-weight: bold;
  margin: 0;
  padding: 0;
`;

const SecondaryHeaderContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

// const SecondaryFooter = styled.div`
//   background-color: ${window.ENV.FOOTER.SECONDARY_FOOTER_BACKGROUND_COLOR};
//   height: ${window.ENV.FOOTER.SECONDARY_FOOTER_HEIGHT};
//   padding: 5px 0;
//   text-align: center;
//   align-items: center;
//   justify-content: center;
//   display: flex;
// `;  

// const SecondaryFooterContent = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `;

// const SecondaryFooterText = styled.p`
//   color: ${window.ENV.FOOTER.SECONDARY_FOOTER_TEXT_COLOR};
//   font-size: 14px;
//   font-weight: bold;
//   margin: 0;
//   padding: 0;
// `;

// ----------------------------------

const NewsletterInput = styled.input`
  padding: 7px 40px 7px 10px;
  font-size: 14px;
  border: 1px solid white;
  border-radius: 4px;
  background-color: ${window.ENV.FOOTER_BACKGROUND_COLOR};
  color: ${window.ENV.GENERAL.TEXT_COLOR};
  width: 100%;
  outline: none;

  &::placeholder {
    color: black;
    opacity: 1;
  }
`;

const NewsletterWrapper = styled.div`
  @media (max-width: 768px) {
    width: 60% !important;
    justify-content: center !important;
    margin:5px 0 0 70px;
  }
`;

const Mainlayout = ({ categoryName, children }) => {

  const dataKey = window.ENV.GOOGLE_SHEET_ID;
  const API_URL = process.env.REACT_APP_API_URL;
  const url = `${API_URL}/${window.ENV.TENANT_NAME}/${window.ENV.DATA_SOURCE}/data`;

  // Replace or define 'productid' appropriately if needed.
  const requestBody = {
    range: "Product!A1:C",
    dataKey: dataKey,
    filters: {

    },
  };

  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProductId, setSelectedProductId] = useState("");
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { cartItems, getCartItemsCount } = useCart();

  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  // Handle cart icon click
  const handleCartClick = () => {
    navigate('/cart');
  };

  // Handle configurator icon click
  const handleConfiguratorClick = () => {
    navigate('/configurator');
  };


  // Fetch data on component mount and log the response to console.
  useEffect(() => {
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => response.json())
      .then((data) => {
        // Extract productId and category from the response
        const productData = data
          .map((item) => {
            if (typeof item === 'object' && !Array.isArray(item)) {
              return { productId: item.productId, categoryName: item.categoryName };
            } else if (Array.isArray(item) && item.length >= 2) {
              return { productId: item[0], categoryName: item[1] };
            }
            return null;
          })
          .filter(item => item); // Remove null values
        setProducts(productData);
        console.log('Products:', productData);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, [url]);


  const filteredProducts = products.filter((product) =>
    product.productId?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
    setIsDropdownVisible(true);
  };
  console.log("searchTerm", searchTerm);
  const [dropdownSearcher, setDropdownSearcher] = useState(false);

  const handleProductSelect = (product) => {
    setSelectedProductId(product.productId);
    setSearchTerm(product.productId);
    setIsDropdownVisible(false);
    setDropdownSearcher(true);

  };

  useEffect(() => {
    if (dropdownSearcher) {
      const selectedProduct = products.find(
        (product) => product.productId === searchTerm
      );
      if (selectedProduct) {
        navigate(`/category/${selectedProduct.categoryName}/productdetails/${selectedProduct.productId}`);
      }
    }
  }, [dropdownSearcher]);


  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      setIsDropdownVisible(false);
      handleSearchIconClick();
    }
  };

  const handleSearchIconClick = () => {
    const selectedProduct = products.find(
      (product) => product.productId === searchTerm
    );
    console.log("selectedProduct is true", selectedProduct);
    if (selectedProduct) {
      navigate(`/category/${selectedProduct.categoryName}/productdetails/${selectedProduct.productId}`);
    }
    else if (searchTerm.trim()) {
      // Navigate to product list page with search term
      navigate(`/productlist/search?search=${encodeURIComponent(searchTerm.trim())}`);
      // Clear the search term after navigation
      setSearchTerm("");
      setIsDropdownVisible(false);
    } else {
      console.error("Please enter a search term");
    }
  };

  const [email, setEmail] = useState("");

  const handleNewsLetter = async () => {
    if (!email) {
      alert("Please enter your email");
      return;
    }

    const url = `${API_URL}/${window.ENV.TENANT_NAME}/send-email`;

    const requestBody = {
      sender: {
        name: window.ENV.EMAIL.SENDER_NAME,
        email: window.ENV.EMAIL.SENDER_EMAILID
      },
      to: [
        {
          email: window.ENV.EMAIL.RECEIVER_EMAILID // Fixed recipient email
        }
      ],
      subject: "Newsletter Subscription",
      htmlContent: `<p>${window.location.host} Newsletter subscriber Email Id : <b>${email}</b></p>`, // Added htmlContent as per API requirement
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestBody)
      });

      const data = await response.json();

      if (response.ok) {
        alert("Newsletter subscription email sent successfully!");
        console.log("Response:", data);
        setEmail(""); // Clear input field after successful submission
      } else {
        alert("Failed to send the email. Please try again.");
        console.error("Error:", data);
      }
    } catch (error) {
      alert("An error occurred while sending the email.");
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownVisible(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <style>
        {`
    body, html {
      overflow-x: hidden;
      width: 100%;
    }
  `}
      </style>
      <LayoutWrapper>
        <header>
          <HeaderDiv>
            <NavLink to={window.ENV.HEADER.MENU2_LINK} target='_blank'>
              <HeaderImg src={`${window.ENV.SERVER_URL}${window.ENV.HEADER_LOGO_URL}`} alt='company-logo' />
            </NavLink>
            <HamburgerIcon onClick={() => setIsMenuOpen(!isMenuOpen)}>
              <FaBars size={20} />
            </HamburgerIcon>

            {(typeof window.ENV.HEADER.SHOW_QUICK_LINKS === "undefined" || window.ENV.HEADER.SHOW_QUICK_LINKS) ? (
              <HeaderNav open={isMenuOpen}>
                <span><a href={window.ENV.HEADER.MENU1_LINK} style={{ textDecoration: 'none', color: window.ENV.HEADER.TEXT_COLOR }}>{window.ENV.HEADER.MENU1_LABEL}</a></span>
                <span><a href={window.ENV.HEADER.MENU2_LINK} target='_blank' style={{ textDecoration: 'none', color: window.ENV.HEADER.TEXT_COLOR }}>{window.ENV.HEADER.MENU2_LABEL}</a></span>
                <span><a href={window.ENV.HEADER.MENU3_LINK} target='_blank' style={{ textDecoration: 'none', color: window.ENV.HEADER.TEXT_COLOR }}>{window.ENV.HEADER.MENU3_LABEL}</a></span>
                <span><a href={window.ENV.HEADER.MENU4_LINK} target='_blank' style={{ textDecoration: 'none', color: window.ENV.HEADER.TEXT_COLOR }}>{window.ENV.HEADER.MENU4_LABEL}</a></span>
              </HeaderNav>

            ) : (
              <></>
            )}

            {(typeof window.ENV.HEADER.SHOW_SEARCH_BAR === "undefined" || window.ENV.HEADER.SHOW_SEARCH_BAR) ? (

              <InputWrapper>
                <StyledInput
                  type="text"
                  placeholder="Search by keyword, brand or item #"
                  value={searchTerm}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                />
                <SearchIconWrapper onClick={handleSearchIconClick}>
                  <FaSearch size={18} />
                </SearchIconWrapper>
                {isDropdownVisible && filteredProducts.length > 0 && (
                  <SearchResults ref={dropdownRef}>
                    {filteredProducts.map((product, index) => (
                      <div
                        key={index}
                        onClick={() => handleProductSelect(product)}
                        style={{
                          textDecoration: "none",
                          color: "#000",
                          display: "block",
                          padding: "5px",
                          cursor: "pointer",
                        }}
                      >
                        {product.productId}
                      </div>
                    ))}
                  </SearchResults>
                )}
              </InputWrapper>

            ) : (
              <></>
            )}
            {(window.ENV.FEATURES && window.ENV.FEATURES.SHOW_CART) &&
              <CartIconWrapper onClick={handleCartClick}>
                <FaShoppingCart size={20} />
                {cartItems.length > 0 && (
                  <CartBadge>{cartItems.length}</CartBadge>
                )}
              </CartIconWrapper>}
            {(window.ENV.FEATURES && window.ENV.FEATURES.SHOW_CONFIGURATOR) &&
              <ConfiguratorIconWrapper onClick={handleConfiguratorClick}>
                <FaCog size={20} />
              </ConfiguratorIconWrapper>
            }
          </HeaderDiv>

          {window.ENV.HEADER.SHOW_SECONDARY_HEADER && (
            <SecondaryHeader>
              <SecondaryHeaderContent>
                <SecondaryHeaderText>
                  {window.ENV.HEADER.SECONDARY_HEADER_TEXT}
                </SecondaryHeaderText>
              </SecondaryHeaderContent>
            </SecondaryHeader>
          )}
          <BreadcrumbsDiv>
            <AppBreadcrumbs categoryName={categoryName} />
          </BreadcrumbsDiv>
        </header>

        {/* {window.ENV.HEADER.SHOW_SECONDARY_HEADER && (
          <SecondaryHeader>
            <SecondaryHeaderContent>
              <SecondaryHeaderText>
                {window.ENV.HEADER.SECONDARY_HEADER_TEXT}
              </SecondaryHeaderText>
            </SecondaryHeaderContent>
          </SecondaryHeader>
        )} */}

        {children}

        {/* Footer Section */}
        <container >
          {/* {window.ENV.FOOTER.SHOW_SECONDARY_FOOTER && (
            <SecondaryFooter>
              <SecondaryFooterContent>
                <SecondaryFooterText>
                  {window.ENV.FOOTER.SECONDARY_FOOTER_TEXT}
                </SecondaryFooterText>
              </SecondaryFooterContent>
            </SecondaryFooter>
          )} */}
          <FooterDiv >
            {/* Quick Links Section */}
            {(typeof window.ENV.FOOTER.SHOW_QUICK_LINKS === "undefined" || window.ENV.FOOTER.SHOW_QUICK_LINKS) ? (
              <FooterColumn>
                <FooterHeading>Quick Links</FooterHeading>
                <FooterNav>
                  <span><a href={window.ENV.FOOTER.MENU1_LINK} style={{ textDecoration: 'none', color: window.ENV.FOOTER.TEXT_COLOR }}>{window.ENV.FOOTER.MENU1_LABEL}</a></span>
                  <span><a href={window.ENV.FOOTER.MENU2_LINK} target='_blank' style={{ textDecoration: 'none', color: window.ENV.FOOTER.TEXT_COLOR }}>{window.ENV.FOOTER.MENU2_LABEL}</a></span>
                  <span><a href={window.ENV.FOOTER.MENU3_LINK} target='_blank' style={{ textDecoration: 'none', color: window.ENV.FOOTER.TEXT_COLOR }}>{window.ENV.FOOTER.MENU3_LABEL}</a></span>
                  <span><a href={window.ENV.FOOTER.MENU4_LINK} target='_blank' style={{ textDecoration: 'none', color: window.ENV.FOOTER.TEXT_COLOR }}>{window.ENV.FOOTER.MENU4_LABEL}</a></span>
                </FooterNav>
              </FooterColumn>
            ) : (
              <></>
            )}

            {/* Email Section */}
            {window.ENV.NEWSLETTER && (
              <FooterColumnResponsive>
                <FooterHeading>Our Newsletter</FooterHeading>
                <FooterText>Email: <br /><NewsletterWrapper style={{
                  position: 'relative',
                  width: '50%',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  gap: '10px',
                }}>

                  <NewsletterInput
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter Your Email"
                    bgColor={window.ENV.GENERAL.BACKGROUND_COLOR}
                    textColor={window.ENV.GENERAL.TEXT_COLOR}
                  />
                  <div style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    color: 'white',

                  }}>
                    <FaTelegramPlane size={20} color="black" onClick={handleNewsLetter} />
                  </div>
                </NewsletterWrapper></FooterText>
                <FooterText>Sign up for our newsletter to receive timely updates, exclusive offers, and exciting news delivered right to your inbox. Subscribe today.</FooterText>
              </FooterColumnResponsive>
            )}

            {/* Logo & Icons Section */}
            <FooterColumnLogo>

              {(typeof window.ENV.FOOTER.SHOW_LOGO === "undefined" || window.ENV.FOOTER.SHOW_LOGO) && (
                <FooterLogoWrapper>
                  <FooterLogo src={`${window.ENV.SERVER_URL}${window.ENV.FOOTER_LOGO_URL}`} alt="footer logo" />
                </FooterLogoWrapper>
              )}

              <FooterIcons>
                {[
                  {
                    label: "Facebook",
                    url: window.ENV.FOOTER.FACEBOOK_URL,
                    icon: <FaFacebook size={24} color="white" />,
                  },
                  {
                    label: "YouTube",
                    url: window.ENV.FOOTER.YOUTUBE_URL,
                    icon: <FaYoutube size={24} color="white" />,
                  },
                  {
                    label: "LinkedIn",
                    url: window.ENV.FOOTER.LINKEDIN_URL,
                    icon: <FaLinkedin size={24} color="white" />,
                  },
                  {
                    label: "Twitter",
                    url: window.ENV.FOOTER.TWITTER_URL,
                    icon: <FaTwitter size={24} color="white" />,
                  },
                  {
                    label: "Pinterest",
                    url: window.ENV.FOOTER.PINTEREST_URL,
                    icon: <FaPinterest size={24} color="white" />,
                  },
                ]
                  .filter(link => link.url && typeof link.url === 'string' && link.url !== 'false')
                  .map((link, idx) => (
                    <a
                      key={link.label}
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={link.label}
                    >
                      {link.icon}
                    </a>
                  ))}
              </FooterIcons>
            </FooterColumnLogo>

            <FooterLine />
          </FooterDiv>

          <FooterCopyRight>
            <p style={{ textAlign: 'center', margin: '0', display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
              {window.ENV.FOOTER.COPY_RIGHTS}. All rights reserved.
              {window.ENV.FOOTER.SHOW_COPY_RIGHTS_FROM && (
                <>
                  &nbsp;&nbsp;&nbsp;From Tre<span style={{ color: 'red' }}>ff</span>er Technologies
                </>
              )}
            </p>
          </FooterCopyRight>
        
        </container>

      </LayoutWrapper>
    </>
  )
}


export default Mainlayout;
